import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, DataUtils, EventManager } from 'ng-jhipster';
import { HebergementBnbaccess } from './hebergement-bnbaccess.model';
import { HebergementBnbaccessService } from './hebergement-bnbaccess.service';
import { Subscription } from 'rxjs/Rx';

@Component({
    selector: 'jhi-hebergement-bnbaccess-detail',
    templateUrl: './hebergement-bnbaccess-detail.component.html'
})
export class HebergementBnbaccessDetailComponent implements OnInit, OnDestroy {

    hebergement: HebergementBnbaccess;
    eventSubscriber: Subscription;
    private subscription: any;
    private id: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private dataUtils: DataUtils,
        private hebergementService: HebergementBnbaccessService,
        private route: ActivatedRoute,
        private eventManager: EventManager,
    ) {
        this.jhiLanguageService.setLocations(['hebergement']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.id = params['id'];
            this.load(this.id);
        });
        this.registerChangeInHebergements();
    }

    registerChangeInHebergements() {
        this.eventSubscriber = this.eventManager.subscribe('hebergementListModification', (response) =>  this.load(this.id));
    }

    load (id) {
        this.hebergementService.find(id).subscribe(hebergement => {
            this.hebergement = hebergement;
        });
    }
    byteSize(field) {
        return this.dataUtils.byteSize(field);
    }

    openFile(contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/hebergement/hebergement-bnbaccess-detail.component.ts